import { useRouter } from "next/router";
import { BuildHTML } from "~/components/BuildHtml/BuildHtml";
import {
  defaultSortOptions,
  GenericSearch,
  ServerGenericSearchProps,
} from "~/components/GenericSearch/GenericSearch";
import { useGenericSearch } from "~/components/GenericSearch/useGenericSearch";
import { landingPageTagToClassNameMap } from "~/components/LandingPageV2/landingPageTagToClassNameMap";
import { landingPageTagToReactConverters } from "~/components/LandingPageV2/landingPageTagToReactConverters";

export type LandingPageSearchProps = ServerGenericSearchProps & {
  /** When true, this hide the side filter area */
  hideSideFilters: boolean;
};

export const LandingPageSearch: React.FC<LandingPageSearchProps> = ({
  categoryOptions,
  contentTypeOptions,
  topicOptions,
  pageSize,
  sectionTitle,
  hideSideFilters,
}) => {
  const router = useRouter();
  const { asPath, replace } = router;
  const onFilterUpdate = (filterString: string) => {
    const [pathname] = asPath.split("?");
    replace(`${pathname}?${filterString}`, undefined, {
      scroll: false,
      shallow: true,
    });
  };

  const {
    enableSearch,
    onCategorySelect,
    onContentTypeSelect,
    onSortSelect,
    onTopicSelect,
    selectedCategory,
    selectedContentType,
    selectedSort,
    selectedTopic,
    searchValue,
    setSearchValue,
  } = useGenericSearch({
    categoryOptions,
    contentTypeOptions,
    sortOptions: defaultSortOptions,
    topicOptions,
    onFilterUpdate,
  });
  return (
    <GenericSearch
      categoryOptions={categoryOptions}
      contentTypeOptions={contentTypeOptions}
      enableQuery={enableSearch}
      onCategorySelect={onCategorySelect}
      onContentTypeSelect={onContentTypeSelect}
      onSortSelect={onSortSelect}
      pageSize={pageSize}
      sectionTitle={
        !!sectionTitle && (
          <BuildHTML
            html={sectionTitle}
            tagToClassNameMap={landingPageTagToClassNameMap}
            tagToReactConverters={landingPageTagToReactConverters}
          />
        )
      }
      selectedCategory={selectedCategory}
      selectedContentType={selectedContentType}
      selectedSort={selectedSort}
      selectedTopic={selectedTopic}
      sortOptions={defaultSortOptions}
      topicOptions={topicOptions}
      onTopicSelect={onTopicSelect}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      hideSideFilters={hideSideFilters}
    />
  );
};
